import { render, staticRenderFns } from "./ModalAlterarSolicitacao.vue?vue&type=template&id=3ba60660&scoped=true"
import script from "./ModalAlterarSolicitacao.vue?vue&type=script&lang=ts"
export * from "./ModalAlterarSolicitacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalAlterarSolicitacao.vue?vue&type=style&index=0&id=3ba60660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba60660",
  null
  
)

export default component.exports